import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { getListIDPClientQuery } from '../apis';
import { setFieldIDPClients } from '..';
import { deepClone } from '@tenant/utility/helper/Utils';
import { useDispatch } from 'react-redux';
import queryKeyAppInstance from '../constants/queryKeyAppInstance';

const useGetListAppInstance = ({ pageSize, pageIndex, searchTerm }) => {
  const dispatch = useDispatch();

  const getListIDPClients = useQuery({
    queryKey: queryKeyAppInstance.getList(
      JSON.stringify({ pageSize, pageIndex }),
    ),
    queryFn: () => getListIDPClientQuery({ pageSize, pageIndex, searchTerm }),
  });

  useEffect(() => {
    dispatch(
      setFieldIDPClients({
        field: 'filter',
        value: { pageSize, pageIndex, searchTerm },
      }),
    );
  }, [pageSize, pageIndex, searchTerm]);

  useEffect(() => {
    const data =
      typeof getListIDPClients !== 'undefined'
        ? getListIDPClients?.data?.data
        : [];

    if (data) {
      dispatch(
        setFieldIDPClients({
          field: 'list',
          value: deepClone(data),
        }),
      );
    }
  }, [getListIDPClients?.data, dispatch]);

  return getListIDPClients;
};

export default useGetListAppInstance;
